import { render, staticRenderFns } from "./SelectSubject.vue?vue&type=template&id=457eafe2&scoped=true"
import script from "./SelectSubject.vue?vue&type=script&lang=js"
export * from "./SelectSubject.vue?vue&type=script&lang=js"
var disposed = false

function injectStyles (context) {
  if (disposed) return
  var style0 = require("./SelectSubject.vue?vue&type=style&index=0&id=457eafe2&scoped=true&lang=css")
if (style0.__inject__) style0.__inject__(context)

}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "457eafe2",
  null
  ,true
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/ecommerce/videochat-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('457eafe2')) {
      api.createRecord('457eafe2', component.options)
    } else {
      api.reload('457eafe2', component.options)
    }
    module.hot.accept("./SelectSubject.vue?vue&type=template&id=457eafe2&scoped=true", function () {
      api.rerender('457eafe2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ChatContent/SelectSubject.vue"
export default component.exports